// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".DashboardFilterBar-base__PGMGb{display:flex;flex-wrap:wrap;gap:var(--size-3);align-items:flex-end}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "DashboardFilterBar-base__PGMGb"
};
export default ___CSS_LOADER_EXPORT___;
